import React, { useState, useEffect } from 'react';
import { ListGroupItem, Col, Breadcrumb, BreadcrumbItem, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import { FaCheck, FaExclamation } from 'react-icons/fa';
import {
    useNavigate
} from "react-router-dom";

// Redux
import { connect } from 'react-redux';

//Componente
import CustomModal from '../../../components/modales/customModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

//API Calls
import { deleteFile, singleFileUploader } from '../../../utils/FirebaseStorage/FirebaseStorage';
const { apiCrearCarpetaNuevoUsuario, apiExisteTrabajador } = require('../../../utils/APIs/APISResume');
const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalFinalizacion = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const navigate  = useNavigate(); 
    const [updFile, setUpdFile] = useState([]);
    const [cedula, setCedula] = useState(props.data.cedulaCandidato);
    const [existeCand, setExisteCand] = useState(true);
    useEffect(() => {
        async function getData() {
            await validarExistenciaCandidato(props.data.cedulaCandidato)
        }
        getData()
    }, [])

    const listadoAdjuntos =[
        {
            required: true,
            name: 'Cédula',
            key: 'CEDULA',
        },
        {
            name:'Documentos Contractuales',
            key:'DOCUMENTOS_CONTRACTUALES',
        },
        {
            name:'Inducciones',
            key:'INDUCCIONES',
        },
        {
            name: 'Radicado EPS',
            key: 'EPS',
        },
        
        {
            required: true,
            name: 'Certificado EPS',
            key: 'CERTIFICADO_EPS',
        },
        {
            name: 'Afiliación CCF',
            key: 'CAJA_DE_COMPENSACION',
        },
        {
            name: 'Radicado AFP',
            key: 'FONDO_PENSIONES',
        },
        {
            name: 'Certificado AFP',
            key: 'CERTIFICADO_PENSIONES',
        },
        {
            name: 'Afiliación ARL',
            key: 'ARL',
        },
        {
            name: 'Radicado AFC',
            key: 'CESANTIAS',
        },
        {
            name: 'Certificado AFC',
            key: 'CERTIFICADO_CESANTIAS',
        },
        
        {
            required: true,
            name: 'Certificado Vacunas',
            key: 'CERTIFICADO_VACUNAS',
        },
        {
            name: 'Certificado Bancario',
            key: 'CERTIFICADO_BANCARIO',
        },
        {
            required: true,
            name: 'Examenes médicos',
            key: 'EXAMENES',
        }
    ]

    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }


    const fileReadyToUpload = (filename) => {
        const newArr = updFile.filter(file => file.key === filename)
        return newArr.length > 0
    }

    const cancelarSolicitud = async () => {
        try {
            Swal.fire({
                title: '¿Desea finalizar el proceso de contratación?',
                html: `La carpeta para el usuario <b>${cedula}</b> será creada y este cambio no es reversible.`,
                // text: `La carpeta para el usuario <b>${cedula}</b> será creada y este cambio no es reversible.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, finalizar!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const body = {
                        cod_soli: props.id,
                        cod_empr: userData.codigoEmpresa,
                        data: {
                            cmp_stat: 'END'
                        }
                    }
                    await actualizarAPE(body)
                    props.toggle()
                    navigate('/home/proceso-contratacion');
                    Swal.fire(
                        'Finalizado!',
                        'Se ha finalizado el proceso de contratación.',
                        'success'
                    )
                }
            })

        }
        catch (error) {
            console.log(error)
            Swal.fire(
                'Error!',
                'Ha ocurrido un error',
                'error'
            )
        }

    }

    const validarExistenciaCandidato = async (id) => {
        const existe = await apiExisteTrabajador({
            cod_empl: id,
            cod_empr: userData.codigoEmpresa
        })
        console.log(existe);
        setExisteCand(existe)
    }

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Revision Proceso de Contratación'}
                buttonTitle={'Aceptar'}
                onClick={() => cancelarSolicitud()}
                buttonLoading={!existeCand}
            // buttonLoading={false}

            >
                <Row>
                    <Col key={`col_datos`} lg='12'>
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Validación KACTUS</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                    <Col key={`col_datos`} lg='12'>
                        <ListGroupItem className='listItem-display-content' key={`cedula_candidato`} color={existeCand ? 'success' : 'danger'}>
                            <div key={`div_cedula_candidato`} className='reclutamiento-list-area'>
                                {`Cedula No: ${cedula}`}
                                {existeCand ? <FaCheck size={16} /> : <FaExclamation size={16} />}
                            </div>
                        </ListGroupItem>
                    </Col>
                </Row>
                <Row style={{ marginTop: '10px' }}>
                    <Col key={`col_datos`} lg='12'>
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Datos Personales y Educación</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                    {listadoAdjuntos.map((doc, index) => {
                        return (
                            <Col key={`col1_${index}`} lg='3' md='6' xs="12">
                                <AttachCardV2
                                    id={`${doc.key}`}
                                    subText={`${doc.name}`}
                                    attached={fileReadyToUpload(`${doc.key}`) || fileExist(`${doc.key}`).exists}
                                    file={fileExist(`${doc.key}`).file}
                                    apeId={props.id}
                                    fileList={props.fileList}
                                    setLoading={(e) => props.setLoading(e)}
                                    setFileList={(e) => { props.setFileList(e) }}
                                />
                            </Col>

                        )
                    })}
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalFinalizacion);